import AsyncStorage from '@react-native-async-storage/async-storage';
import moment from 'moment/moment';
import React, {useEffect, useState} from 'react';
import {
   Image,
   Platform,
   SafeAreaView,
   ScrollView,
   StatusBar,
   StyleSheet,
   Text,
   TextInput,
   TouchableOpacity,
   View,
} from 'react-native';
import {CopyRight} from '../../utils/CopyRight';
import {
   appBackground,
   AUTHDATA,
   base100,
   DASHBOARD,
   MYTRAINING,
   norcatAppColor,
   primaryColor500,
   primaryState800,
   PROFILE,
   white,
   FONT_FAMILY_SEMI_BOLD,
   FONT_FAMILY_MEDIUM,
   FONT_FAMILY_REGULAR,
   getNorcatId,
   getQRCode,
   getFirstName,
   getEmail,
   getPhoneNumaber,
   getLastName,
   getDob,
   primaryColor900a,
   BROUS,
   profileTextBG,
   BUTTON_HOVER_COLOR,
   isWeb,
} from '../../utils/utils';
import ProfileHeader from './ProfileHeader';
import {retrieveAppData} from '../../utils/preference';
import {ApplicationHeader} from '../../utils/application_header';
import {useNavigation} from '@react-navigation/native';
import {useSelector} from 'react-redux';
import {selectScreenOrientation} from '../../redux/slices/ScreenOrientationSlice';
import Landscap_Application_Header from '../../utils/Landscap_Application_Header';
import DashboardHeader from '../dashboard/DashboardHeader';
import DashboardHeaderLandsacap from '../dashboard/DashboardHeaderLandsacap';
import DashboardRightPanel from '../dashboard/DashboardRightPanel';
import {selectAuthData} from '../../redux/slices/AuthSlice';
import logger from '../../utils/logger';

const ProfileScreen = () => {
   const navigation = useNavigation();
   const isLandscapemode = useSelector(selectScreenOrientation);
   const [checked, setChecked] = useState(false);
   const [isHover, setHover] = React.useState(false);
   // const [authData, setAuthData] = useState({});
   const authData = useSelector(selectAuthData);

   useEffect(() => {
      (async () => {
         // const authData = await retrieveAppData(AUTHDATA);
         // setAuthData(JSON.parse(authData));
      })();
   }, []);

   function handleCheckClick() {
      const rem = !checked ? 'true' : 'false';
      setChecked(!checked);
   }

   return (
      <View
         style={[
            styles.container,
            {
               ...Platform.select({
                  web: {
                     flex: null,
                     height: '100%',
                     minHeight: '100vh',
                     overflowY: isLandscapemode ? 'hidden' : null,
                  },
               }),
            },
         ]}>
         {!isLandscapemode ? (
            <ApplicationHeader
               OnBackPress={() => {
                  navigation.goBack();
               }}
               onLogOutPress={() => {
                  navigation.navigate('LogoutScreen');
               }}
               onEditPress={() => {
                  navigation.navigate('EditProfileScreen');
               }}
               title="Profile"
               isProfileEnable={true}
            />
         ) : (
            <Landscap_Application_Header
               authData={authData}
               selectedTab={PROFILE}
               onTopMenuClick={value => {
                  if (value === DASHBOARD) {
                     navigation.navigate('DashboardScreen');
                  } else if (value === MYTRAINING) {
                     navigation.navigate('MyTraningScreen');
                  } else if (value === PROFILE) {
                     navigation.navigate('ProfileScreen');
                  } else if (value === BROUS) {
                     navigation.navigate('BrowsesCoursesScreen');
                  }
               }}
               dataSource={['Edit Profile', 'Logout']}
            />
         )}
         {!isLandscapemode ? (
            <View style={{flex: 1}}>
               <ProfileHeader
                  title="Account Details"
                  subTitle={authData.CompanyName}
                  icon={require('../../assets/userIcon.png')}
                  authData={authData}
                  onQrClick={() => {
                     // To do , uncomment below line and remove handlePress(); call
                     navigation.navigate('QRAndBarcodeScreen', {
                        norcatID: getNorcatId(authData),
                        qrID: getQRCode(authData), //authData.QRID,
                     });
                  }}
               />
               <ProfileView authData={authData} />
               <View>
                  <CopyRight isProfileScreen={true} />
               </View>
            </View>
         ) : (
            <View
               style={{
                  flexDirection: 'row',
                  flex: 1,
                  ...Platform.select({
                     web: {
                        minHeight: 500,
                     },
                  }),
               }}>
               <View style={{flex: 1}}>
                  <DashboardHeaderLandsacap
                     subtitle={authData.CompanyName}
                     icon={require('../../assets/user.png')}
                     title="My Profile"
                     showCourses={false}
                     showSearchView={false}
                     showFilterTabs={false}
                     showRecordTabs={false}
                     showFooter={true}
                     showRefreshIcon={false}
                     authData={authData}
                  />
                  <ProfileViewLandScap authData={authData} />
                  <View
                     style={{
                        flexDirection: 'row-reverse',
                        paddingVertical: 16,
                        paddingHorizontal: 16,
                     }}>
                     <TouchableOpacity
                        style={{
                           backgroundColor: isHover
                              ? BUTTON_HOVER_COLOR
                              : primaryColor500,
                           minHeight: 48,
                           paddingHorizontal: 16,
                           borderRadius: 6,
                           justifyContent: 'center',
                        }}
                        onMouseEnter={() => {
                           setHover(true);
                        }}
                        onMouseLeave={() => {
                           setHover(false);
                        }}
                        onPress={() => {
                           navigation.navigate('EditProfileScreen');
                        }}>
                        <View
                           style={{
                              flexDirection: 'row',
                              justifyContent: 'center',
                              alignContent: 'center',
                              alignItems: 'center',
                           }}>
                           <Text
                              style={{
                                 color: 'white',
                                 fontSize: 16,
                                 fontWeight: '500',
                                 textAlign: 'center',
                                 fontFamily: FONT_FAMILY_MEDIUM,
                              }}>
                              Edit Profile
                           </Text>
                           <Image
                              source={require('../../assets/edit_black.png')}
                              style={{
                                 marginStart: 10,
                                 tintColor: 'white',
                                 height: 18,
                                 width: 18,
                              }}
                           />
                        </View>
                     </TouchableOpacity>
                  </View>
                  <CopyRight
                     screenOrientation={isLandscapemode}
                     isCopyrightShown={isLandscapemode ? true : false}
                  />
               </View>
               <View
                  style={{
                     flex: 0.4,
                     ...Platform.select({
                        web: {
                           flex: isLandscapemode ? null : 0.4,
                           width: isLandscapemode ? '30%' : null,
                           height: isLandscapemode ? '90vh' : null,
                        },
                     }),
                  }}>
                  <DashboardRightPanel
                     showProgressView={false}
                     showName={false}
                     authData={authData}
                     maxHeight="83%"
                     onQrClick={() => {
                        navigation.navigate('QRAndBarcodeScreen', {
                           norcatID: getNorcatId(authData),
                           qrID: getQRCode(authData), //authData.QRID,
                        });
                     }}
                  />
               </View>
            </View>
         )}
      </View>
   );
};

const ProfileViewLandScap = props => {
   return (
      <View style={styles.profileStyleLandscap}>
         <View style={{flexDirection: 'column', flex: 1, marginEnd: 16}}>
            <Text style={styles.titleStyle}>First Name</Text>
            <View style={styles.inputStyle}>
               <Text style={styles.textStyle}>
                  {getFirstName(props.authData)}
               </Text>
            </View>
            <Text style={styles.titleStyle}>User Name</Text>
            <View style={styles.inputStyle}>
               <Text style={styles.textStyle}>{getEmail(props.authData)}</Text>
            </View>
            <Text style={styles.titleStyle}>Phone Number</Text>
            <View style={styles.inputStyle}>
               <Text style={styles.textStyle}>
                  {getPhoneNumaber(props.authData)}
               </Text>
            </View>
         </View>
         <View style={{flexDirection: 'column', flex: 1, marginStart: 16}}>
            <Text style={styles.titleStyle}>Last Name</Text>
            <View style={styles.inputStyle}>
               <Text style={styles.textStyle}>
                  {getLastName(props.authData)}
               </Text>
            </View>
            <Text style={styles.titleStyle}>Email</Text>
            <View style={styles.inputStyle}>
               <Text style={styles.textStyle}>{getEmail(props.authData)}</Text>
            </View>
            <Text style={styles.titleStyle}>Date of Birth</Text>
            <View style={styles.inputStyle}>
               <Text style={styles.textStyle}>
                  {formateDate(getDob(props.authData))}
               </Text>
            </View>
         </View>
      </View>
   );
};

const ProfileView = props => {
   return (
      <ScrollView style={{flex: 1}}>
         <View style={styles.profileStyle}>
            <Text style={styles.titleStyle}>First Name</Text>
            <View style={styles.inputStyle}>
               <Text style={styles.textStyle}>
                  {getFirstName(props.authData)}
               </Text>
            </View>
            <Text style={styles.titleStyle}>Last Name</Text>
            <View style={styles.inputStyle}>
               <Text style={styles.textStyle}>
                  {getLastName(props.authData)}
               </Text>
            </View>
            <Text style={styles.titleStyle}>Username</Text>
            <View style={styles.inputStyle}>
               <Text style={styles.textStyle}>{getEmail(props.authData)}</Text>
            </View>
            <Text style={styles.titleStyle}>Date of Birth</Text>
            <View style={styles.inputStyle}>
               <Text style={styles.textStyle}>
                  {formateDate(getDob(props.authData))}
               </Text>
            </View>
            <Text style={styles.titleStyle}>Phone Number</Text>
            <View style={styles.inputStyle}>
               <Text style={styles.textStyle}>
                  {getPhoneNumaber(props.authData)}
               </Text>
            </View>
         </View>
      </ScrollView>
   );
};

function formateDate(date) {
   return moment(date).format('MM-DD-YYYY');
}

const styles = StyleSheet.create({
   container: {
      backgroundColor: white,
      flex: 1,
      paddingBottom: isWeb ? 10 : 0,
   },
   inputStyle: {
      width: '100%',
      height: 40,
      backgroundColor: profileTextBG,
      marginTop: 8,
      borderWidth: 0,
      paddingHorizontal: 14,
      borderColor: profileTextBG,
      borderRadius: 6,
      justifyContent: 'center',
   },
   textStyle: {
      fontSize: 14,
      color: '#000000',
      fontWeight: '700',
      fontFamily: FONT_FAMILY_REGULAR,
   },
   titleStyle: {
      fontSize: 14,
      marginTop: 16,
      color: '#000000',
      fontWeight: '600',
      fontFamily: FONT_FAMILY_REGULAR,
   },
   profileStyle: {
      paddingHorizontal: 16,
      paddingVertical: 8,
      flexDirection: 'column',
   },
   profileStyleLandscap: {
      paddingHorizontal: 16,
      paddingVertical: 8,
      flexDirection: 'row',
   },
});

export default ProfileScreen;
